<!-- Секция кейсов - Organism -->
<template>
    <section class="relative bg-black overflow-hidden py-16 lg:py-24">
        <!-- Фоновые элементы -->
        <div class="absolute inset-0">
            <div class="absolute inset-0 bg-[rgba(22,22,22,0.33)]" />
        </div>

        <div class="relative z-10 mx-auto max-w-7xl px-6">
            <!-- Заголовок -->
            <h2
                class="text-center text-[76.319px] md:text-[170px] font-medium leading-[100%] mb-8 lg:mb-16 bg-gradient-to-r from-white via-white to-transparent bg-clip-text">
                Кейсы
            </h2>

            <!-- Expandable Gallery со слайдером -->
            <div class="cases-gallery-wrapper">
                <ExpandableGallery :items="casesForGallery" :visible-items="4" :keyboard-navigation="true"
                    @item-click="handleCaseClick">
                    <!-- Кастомный контент для каждого элемента галереи -->
                    <template #default="{ item }">
                        <CaseCard :artist-name="item.artistName" :label="item.label" :description="item.description" />
                    </template>
                </ExpandableGallery>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import CaseCard from '@/components/molecules/CaseCard.vue'
import ExpandableGallery from '@/components/ui/ExpandableGallery.vue'

interface CaseStudy {
    artistName: string
    label?: string
    description?: string
}

const emit = defineEmits<{
    'case-click': [caseStudy: CaseStudy, index: number]
}>()

// Примеры кейсов - увеличил количество для демонстрации слайдера
const cases = ref<CaseStudy[]>([
    {
        artistName: 'Иван Петров',
        label: 'артист Touch',
        description: 'за 3 месяца с 0 до 100.000 прослушиваний на Spotify'
    },
    {
        artistName: 'Мария Иванова',
        label: 'артист Touch',
        description: 'вышла на топ-50 чарта Apple Music за 2 месяца'
    },
    {
        artistName: 'Дмитрий Сидоров',
        label: 'артист Touch',
        description: 'достиг 1 млн прослушиваний за 6 месяцев'
    },
    {
        artistName: 'Анна Смирнова',
        label: 'артист Touch',
        description: 'запустила первый альбом на 10+ площадках'
    },
    {
        artistName: 'Алексей Ковалев',
        label: 'артист Touch',
        description: 'увеличил аудиторию в 5 раз за 4 месяца'
    },
    {
        artistName: 'Елена Волкова',
        label: 'артист Touch',
        description: 'набрала 500К прослушиваний за первый месяц релиза'
    },
    {
        artistName: 'Сергей Новиков',
        label: 'артист Touch',
        description: 'вошёл в топ-100 глобального чарта Spotify'
    },
    {
        artistName: 'Ольга Морозова',
        label: 'артист Touch',
        description: 'выпустила EP и собрала 2М стримов за квартал'
    }
])

// Преобразуем данные для галереи
const casesForGallery = computed(() =>
    cases.value.map((caseItem) => ({
        ...caseItem,
        // Можно добавить image, если нужно для фона
    }))
)

const handleCaseClick = (item: any, index: number) => {
    emit('case-click', item, index)
}
</script>

<style scoped>
.cases-gallery-wrapper {
    /* Дополнительная обертка для контроля отступов и позиционирования */
    position: relative;
}

/* Адаптивность заголовка */
h2 {
    font-family: 'Halvar Breitschrift', sans-serif;
    background: linear-gradient(100deg, #FFF 40.34%, rgba(255, 255, 255, 0.00) 135.88%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

@media (max-width: 1023px) {
    .cases-gallery-wrapper {
        margin-top: 0;
    }

    h2 {
        font-size: 56px;
        margin-bottom: 2rem;
    }
}

@media (max-width: 768px) {
    .cases-gallery-wrapper {
        margin-top: 0;
    }

    h2 {
        font-size: 48px;
    }
}
</style>
